import { useEffect, useState, type RefObject } from 'react';

export type UseIntersectionObserverOptions = IntersectionObserverInit;

export default function useIntersectionObserver<T extends Element>(
  ref: RefObject<T | null>,
  options?: UseIntersectionObserverOptions,
) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!ref.current) return;

    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (!entry) return;
      setIsIntersecting(entry.isIntersecting);
    }, options);

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, options]);

  return isIntersecting;
}
